import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license-pro';
import { Helmet } from 'react-helmet';
import router from './router';

// ✅ Set your MUI X Pro license key
LicenseInfo.setLicenseKey(
    '7bff1e4f77143e3fac5b4728f2a63df5Tz03MDkwOCxFPTE3MjEzMDA3OTYwMDAsUz1wcm8sLEtWPTI='
);

const App = () => {
    return (
        <>
            <Helmet>
                <script type="text/javascript">
                    {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "u0w7g1msbc");
          `}
                </script>
            </Helmet>

            <RouterProvider router={router} />
        </>
    );
};

export default App;
